const TrendingUp = ({ size=15, color="#12a87a", ...props }) => (
    <svg
        width={size}
        height={size}
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M16 7h6v6" />
        <path d="M22 7l-8.5 8.5-5-5L2 17" />
    </svg>
);

export default TrendingUp;
